<template>
  <div>
    <Toast />
    <ConfirmDialog />

    <Dialog
      v-model:visible="popupOpen"
      :breakpoints="{ '960px': '75vw', '640px': '90vw' }"
      :style="{ width: '50vw' }"
      :modal="true"
      :closable="false"
    >
      <template #header>
        <h3 style="color: #0064f9">{{ updateShown.titolo }}</h3>
      </template>

      <p class="m-0" v-html="updateShown.testo"></p>

      <template #footer>
        <Button
          label=""
          icon="pi pi-check"
          @click="popupClose"
          autofocus
          style="width: 60px; height: 45px"
        />
      </template>
    </Dialog>

    <TheNavbar style="padding-bottom: 0" v-show="!showCleanView" />
    <main
      role="main"
      :class="
        $route.name != 'clientMailCV'
          ? 'main-container'
          : 'main-container-dialog'
      "
    >
      <router-view v-slot="slotProps">
        <transition name="route" mode="out-in">
          <component :is="slotProps.Component"></component>
        </transition>
      </router-view>
    </main>
    <TheFooter v-show="!showCleanView" />
  </div>
</template>

<script>
import TheNavbar from "./TheNavbar.vue";
import TheFooter from "./TheFooter.vue";

import { useStore } from "vuex";
import { ref, watch } from "vue";

export default {
  setup() {
    const store = useStore();

    const updates = ref([]);
    const popupOpen = ref(false);
    const updateShown = ref();
    const notificationTimer = ref();

    async function getUpdate() {
      var user_tmp = await store.getters["auth/getUser"];
      if (user_tmp) {
        var user = JSON.parse(await store.getters["auth/getUser"]);
        if (user.packLevel > 0) {
          updates.value = await store.dispatch("updates/getUpdate");
          if (updates.value) {
            // console.log(updates.value);
          }
        }
      }
      clearTimeout(notificationTimer.value);
      notificationTimer.value = setTimeout(async () => {
        getUpdate();
      }, 30000);
    }

    async function setUpdateViewed() {
      var newUpdate = {
        viewed: updateShown.value._id,
      };
      var viewed = await store.dispatch("updates/setUpdateViewed", newUpdate);
      // console.log(viewed);
      popupOpen.value = false;
    }

    function popupClose() {
      setUpdateViewed();
    }

    watch(updates, () => {
      if (updates.value.length > 0 && !popupOpen.value) {
        popupOpen.value = true;
        updateShown.value = updates.value.pop();
        // console.log(updateShown.value);
      }
    });
    getUpdate();
    setInterval(getUpdate(), 5 * 1000 * 60 * 60);

    return {
      getUpdate,
      popupOpen,
      updateShown,
      popupClose,
    };
  },

  data() {
    return {
      packLevel: 10,
    };
  },
  components: {
    TheNavbar,
    TheFooter,
  },
  provide() {
    return {
      links: this.links,
    };
  },
  computed: {
    showCleanView() {
      if (this.$route.meta.visualLevel > 0) {
        return false;
      } else {
        return true;
      }
    },
  },
};
</script>

<style scoped src="../../assets/css/components/UI/TheMain_scoped.css"></style>
<style>
@import "../../assets/css/components/UI/TheMain_general.css";
</style>
